module.exports = __webpack_public_path__ + "img/fe_backdrop_sparta.0f1493fc.png";